import React from 'react';

const ChartLine = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 13.0003V14.5001C2.5 15.4335 2.5 15.8999 2.68166 16.2564C2.84144 16.57 3.09623 16.8255 3.40983 16.9853C3.766 17.1667 4.23249 17.1667 5.16409 17.1667H17.5002M2.5 13.0003V4.66675M2.5 13.0003L5.71116 10.3243L5.71382 10.3222C6.29472 9.83809 6.58573 9.59557 6.90129 9.49707C7.27406 9.38071 7.67559 9.39911 8.0363 9.54875C8.34208 9.6756 8.61021 9.94373 9.14647 10.48L9.15185 10.4854C9.69643 11.0299 9.96944 11.303 10.2801 11.4295C10.6478 11.5793 11.0571 11.5922 11.4339 11.4672C11.7534 11.3613 12.0452 11.1064 12.6286 10.5959L17.5 6.33341"
      stroke="#6B6C7B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChartLine;
